import { render, staticRenderFns } from "./terms_of_use.vue?vue&type=template&id=159469e0&scoped=true"
import script from "./terms_of_use.vue?vue&type=script&lang=js"
export * from "./terms_of_use.vue?vue&type=script&lang=js"
import style0 from "./terms_of_use.vue?vue&type=style&index=0&id=159469e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159469e0",
  null
  
)

export default component.exports